import { AcceptType } from '@components/file-field/types';
import { InstantUploadFileFieldProps } from '@components/instant-upload-file-field/instant-upload-file-field';
import {
  BaseFieldMappingFieldProps,
  ExtendedFieldMappingEditorValue,
  FieldMappingData,
  transformSimpleValueOutput,
} from '@components/text-editors/addons/field-mapping';
import { NodeStyledFieldMappingTextEditor } from '@components/text-editors/field-mapping-text-editor';
import { useScopedTranslate } from '@locale/translate';

import { FilePlaceholder, tag, transformInput } from './extensions';

export type FieldMappingFileListFieldProps = BaseFieldMappingFieldProps<
  ExtendedFieldMappingEditorValue[]
> &
  FieldMappingData &
  Partial<Pick<InstantUploadFileFieldProps, 'onSelect' | keyof AcceptType>> & {
    allowUploadFiles?: boolean;
  };

export const FieldMappingFileListField = ({
  accept,
  fileType,
  defaultValue,
  onChange,
  onSelect,
  extensions = [],
  allowUploadFiles = true,
  ...rest
}: FieldMappingFileListFieldProps) => {
  const { t } = useScopedTranslate(locale);

  return (
    <NodeStyledFieldMappingTextEditor
      extensions={[FilePlaceholder, ...extensions]}
      plaintext
      singleLine
      onChange={(value) => onChange?.(transformSimpleValueOutput(value, tag))}
      defaultValue={defaultValue ? transformInput(defaultValue) : undefined}
      placeholder={t('placeholder')}
      disabled
      shouldShowFieldMappingOnFocus
      fieldType="file"
      onManualSelect={allowUploadFiles ? onSelect : undefined}
      {...rest}
    />
  );
};

const locale = {
  en: {
    fieldMap: 'Field map',
    fieldMapDescription: 'Receive value from a field in journey',
    fileLabel: 'File',
    placeholder: 'Select or add file...',
    uploadFile: 'Upload file',
    manuallyUploadFile: 'Manually upload a file',
    add: 'Add',
  },
  is: {
    fieldMap: 'Ráðningargögn',
    fieldMapDescription: 'Nota gildi frá reit í ferli',
    fileLabel: 'Skjal',
    placeholder: 'Velja eða bæta við...',
    uploadFile: 'Hlaða upp skrá',
    manuallyUploadFile: 'Hlaða upp skrá handvirkt',
    add: 'Bæta við',
  },
};
